import { useNavigation } from '@eleveo/components-react';
import clsx from 'clsx';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { NavigationList } from './NavigationList';
import { useAuth } from '../../../app/AuthorizationProvider';
import { getNavItems } from '../../../router/navItems';

export const Navigation: React.FC = () => {
  const { isOpen } = useNavigation();
  const { userHasPermissions } = useAuth();
  const [openedTree, setOpenedTree] = React.useState('/');
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const navItems = useMemo(
    () => getNavItems(t).filter((navItem) => userHasPermissions(navItem.requiredPermissions, false)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    setOpenedTree(pathname);
  }, [pathname]);

  return (
    <nav className={clsx('navigation', { 'navigation--collapsed': !isOpen })} role="navigation">
      <NavigationList items={navItems} openedTree={openedTree} pathname={pathname} setOpenedTree={setOpenedTree} />
    </nav>
  );
};
